import React from "react";

const Links = ({ french }) => {
  return (
    <div className="container">
      <div className="container__page">
        <div className="links">
          {french ? (
            <>
              <h1>
                <span>Liens</span>
              </h1>
              <div>
                <h2>
                  <span>Enregistrements</span>
                </h2>
                <h3 className="links-multiple">
                  <a
                    href="https://youtu.be/KIEHooNhibQ?si=9aDYLDPmBXjKE8U-"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Double Dutch Treat
                  </a>
                  <span>, </span>
                  <a
                    href="https://youtu.be/cZiFh5YK3V8?si=lDy_EHn1ocX1lrys"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Hooray for Herbie
                  </a>
                  <span>, </span>
                  <a
                    href="https://youtu.be/fhxV0TTqdKA?si=_JZKDDlHrgfUc2RV"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Trapeze Song
                  </a>
                  <span>, </span>
                  <a
                    href="https://youtu.be/fNDtcaSAPxA?si=6d2HXbX5sBTekG9b"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Ola Ou Kale
                  </a>
                  <span> | </span>
                  Jazzland, 14 Mai 2026 - Claudine François, Tobias Pustelnik,
                  Andjelko Stupar, Klaus Melem
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/oHrk6bciFX4?si=cJC_6tVANFnqUrsO"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Traversées
                  </a>
                  <span> | </span>
                  Composition par Magali RUBIO - Clarinette basse & Claudine
                  FRANÇOIS - Piano
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/UPtcldyQv6I?si=rBuTfOIWrvZpGhoW"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Seven for Yao
                  </a>
                  <span> | </span>
                  Composition par Claudine FRANÇOIS - Clarinette basse &
                  Claudine FRANÇOIS - Piano
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/V8tqSDwuYwU?si=pdQolx_2l7MhZCax"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Céleste Duo
                  </a>
                  <span> | </span>
                  Composition par Magali RUBIO - Clarinette basse & Claudine
                  FRANÇOIS - Piano
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/RX-IG_yvMds?si=0uFsJX-tHAwPrAfV"
                    rel="noreferrer"
                    target="_blank"
                  >
                    MAWÉ BIGUINE LA
                  </a>
                  <span> | </span>
                  Composition par Claudine FRANÇOIS - Flûte & Claudine FRANÇOIS
                  - Piano
                </h3>
                <h2>
                  <span>Sites de musiciens</span>
                </h2>
                <h3>
                  <a
                    href="https://www.danrosemusic.com/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    danrosemusic.com
                  </a>
                  <span> | </span>
                  site du guitariste américain Dan Rose
                </h3>
                <h3>
                  <a
                    href="http://brice.wassy.free.fr/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    brice.wassy.free.fr
                  </a>
                  <span> | </span>
                  site du batteur camerounais Brice Wassy
                </h3>
                <h2>
                  <span>Autres sites</span>
                </h2>
                <h3>
                  <a
                    href="https://www.jazzhot.net/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    jazzhot.net
                  </a>
                  <span> | </span>
                  site du magazine avec accès aux suppléments internet
                </h3>
                <h3>
                  <a
                    href="https://www.citizenjazz.com/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    citizenjazz.com
                  </a>
                  <span> | </span>
                  Chroniques, forums sur le jazz et aux musiques improvisées
                </h3>
                <h3>
                  <a
                    href="http://africultures.com/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    africultures.com
                  </a>
                  <span> | </span>
                  Toutes les cultures africaines
                </h3>
              </div>
            </>
          ) : (
            <>
              <h1>
                <span>Links</span>
              </h1>
              <div>
                <h2>
                  <span>Recordings</span>
                </h2>
                <h3 className="links-multiple">
                  <a
                    href="https://youtu.be/KIEHooNhibQ?si=9aDYLDPmBXjKE8U-"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Double Dutch Treat
                  </a>
                  <span>, </span>
                  <a
                    href="https://youtu.be/cZiFh5YK3V8?si=lDy_EHn1ocX1lrys"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Hooray for Herbie
                  </a>
                  <span>, </span>
                  <a
                    href="https://youtu.be/fhxV0TTqdKA?si=_JZKDDlHrgfUc2RV"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Trapeze Song
                  </a>
                  <span>, </span>
                  <a
                    href="https://youtu.be/fNDtcaSAPxA?si=6d2HXbX5sBTekG9b"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Ola Ou Kale
                  </a>
                  <span> | </span>
                  Jazzland, May 14th 2026 - Claudine François, Tobias Pustelnik,
                  Andjelko Stupar, Klaus Melem
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/oHrk6bciFX4?si=cJC_6tVANFnqUrsO"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Traversées
                  </a>
                  <span> | </span>
                  Composition by Magali RUBIO - Bass clarinet & Claudine
                  FRANÇOIS - Piano
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/UPtcldyQv6I?si=rBuTfOIWrvZpGhoW"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Seven for Yao
                  </a>
                  <span> | </span>
                  Composition by Claudine FRANÇOIS - Bass clarinet & Claudine
                  FRANÇOIS - Piano
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/V8tqSDwuYwU?si=pdQolx_2l7MhZCax"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Céleste Duo
                  </a>
                  <span> | </span>
                  Composition by Magali RUBIO - Bass clarinet & Claudine
                  FRANÇOIS - Piano
                </h3>
                <h3>
                  <a
                    href="https://youtu.be/RX-IG_yvMds?si=0uFsJX-tHAwPrAfV"
                    rel="noreferrer"
                    target="_blank"
                  >
                    MAWÉ BIGUINE LA
                  </a>
                  <span> | </span>
                  Composition by Claudine FRANÇOIS - Flute & Claudine FRANÇOIS -
                  Piano
                </h3>
                <h2>
                  <span>Sites of fellow musicians</span>
                </h2>
                <h3>
                  <a
                    href="https://www.danrosemusic.com/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    danrosemusic.com
                  </a>
                  <span> | </span>
                  American guitarist Dan Rose
                </h3>
                <h3>
                  <a
                    href="http://brice.wassy.free.fr/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    brice.wassy.free.fr
                  </a>
                  <span> | </span>
                  Cameroonian drummer Brice Wassy
                </h3>
                <h2>
                  <span>Other sites of interest</span>
                </h2>
                <h3>
                  <a
                    href="https://www.jazzhot.net/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    jazzhot.net
                  </a>
                  <span> | </span>
                  Site of the French magazine with Internet bonus
                </h3>
                <h3>
                  <a
                    href="https://www.citizenjazz.com/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    citizenjazz.com
                  </a>
                  <span> | </span>
                  Reviews, forums on jazz and improvised music
                </h3>
                <h3>
                  <a
                    href="http://africultures.com/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    africultures.com
                  </a>
                  <span> | </span>
                  All African cultures
                </h3>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Links;
